import { inject } from 'vue'
import { modalContextKey } from './types'

export default function useModal() {
  return inject(modalContextKey)
}
